import { Observable } from 'rxjs';
import { ApiBase } from '../api/api.base';
import { Tso } from 'ts-odata';
import { ApiResultado } from '../models/api-resultado';
import { map } from 'rxjs/operators';

export abstract class ServiceBase<TModel, IDTo> {

    constructor(private baseApi: ApiBase) { }

    getQuery(): Tso {
        return this.baseApi.createQuery();
    }

    odata(query: Tso): Observable<ApiResultado<IDTo>> {

        if (query.SelectSettings.select.indexOf("Id") == -1) {
            query.SelectSettings.select.unshift("Id");
        }

        return this.baseApi.odataQuery(query).pipe(
            map(resp => {
                let resultado = new ApiResultado<IDTo>();
                resultado.Count = resp.headers.get('X-Count');
                resultado.Now = resp.headers.get('X-Now');
                resultado.Data = resp.body;

                return resultado;
            })
        );
    }

    get(id: number): Observable<TModel> {
        return this.baseApi.get(id);
    }

    create(user: any): Observable<TModel> {
        return this.baseApi.add(user);
    }

    update(user: any): Observable<TModel> {
        return this.baseApi.update(user);
    }

    delete(id: number | string): Observable<boolean> {
        return this.baseApi.delete(id);
    }
}
